import i18n from '../i18n';
import en from '../i18n/en_US';
import fr from '../i18n/fr_FR';
export default {
  i18n: {
    messages: {
      en,
      fr,
    },
  },
  computed: {},
  methods: {
    addBlockCustom_Column2(blockManager) {
      blockManager.add('custom_column2', {
        label: this.$i18n.t('blocks.custom_column2'),
        category: 'Areas',
        resizable: false,
        name: 'custom_column2',
        attributes: {
          class: 'gjs-fonts gjs-f-b2 ', //icon in the panel
          type: 'custom_column2',
        },
        content: `
	      <div class="row-custom"  data-gjs-type="custom_column2" data-gjs-droppable=".row-cell" data-gjs-custom-name="Row">
		      <div data-gjs-type="custom_column" data-gjs-custom-name="Col"  class="row-cell-1" data-gjs-draggable=".row"></div>
		      <div data-gjs-type="custom_column" data-gjs-custom-name="Col" class="row-cell-2" data-gjs-draggable=".row"></div>
	      </div>
	      <style>
		      .row-custom {
		          display: flex;
		          justify-content: flex-start;
		          align-items: stretch;
		          flex-wrap: nowrap;
		          height: 100%;
		      }
		      .row-cell-1,.row-cell-2 {
		         flex-grow: 1;
		         flex-basis: 100%;
		       }
	      </style>
      `,
      });
    },
    async updateCategoryBlockManger(editor, getParamsClients) {
      let allBlocks = editor.BlockManager.getAll().models.map(block => {
        return block.id;
      });
      let CurrentBlock = [];
      if (
        getParamsClients.display_default_blocks !== null ||
        Object.keys(getParamsClients.display_default_blocks).length > 0
      ) {
        let blocks = getParamsClients.display_default_blocks.map(block => {
          return block.blocks;
        });
        let names = getParamsClients.display_default_blocks.map(item => {
          return item.name;
        });
        let bg = ['#ff9800', '#039be5', '#8bc34a', '#9872e8', '#f44336'];
        const borderBlock = 'gjs-four-color-h';
        const labelBlock = 'gjs-block-label';
        const hiddenBlock = 'emp-gjs-block';
        let styleNew = `<style>
           .${borderBlock}{
                 border: 1px solid #b7bbc5 !important;
             }
             .${labelBlock}{
                 font-size: 0.9rem;
                 font-weight: 600;
             }
              .${hiddenBlock} {
            display: none!important;
            }
          </style>`;

        blocks.forEach((block, index) => {
          for (let i = 0; i < block.length; i++) {
            //Add new custom_column2
            if (block[i] === 'custom_column2') {
              this.addBlockCustom_Column2(editor.BlockManager);
            }
            if (
              block[i].indexOf('custom-title') > -1 ||
              block[i].indexOf('custom-sharing') > -1 ||
              block[i].indexOf('custom-credit') > -1
            ) {
              this.addSpecificBlocText(block[i], editor);
            }
            if (!editor.BlockManager.get(block[i])) {
              continue;
            }
            const parentClass = 'block-parent' + index;
            let style =
              `<style>
            .${parentClass} {
               color:` +
              bg[index] +
              `!important;
             }           
          </style>`;
            if (Object.keys(getParamsClients.display_default_blocks).length <= 2) {
              bg = '#78929f';
              const parentBlocks = 'gjs-blocks-c';
              style =
                `<style>
             .${parentBlocks} {
              display: flex;
              flex-direction: column;
            }
            .${parentClass} {
               color:` +
                bg +
                `!important;
               display: flex;
               flex-direction: column;
               width: 100%!important;
             }
          
          </style>` +
                styleNew;
            }
            CurrentBlock = CurrentBlock.concat(block[i]);

            editor.BlockManager.get(block[i]).set({
              category:
                `${style} <div class="emp-gjs-block " id="emp-gjs-block-` +
                names[index].toLowerCase() +
                `" style="background:` +
                bg[index] +
                `; color: white;margin-top: 5px;" title="` +
                this.$i18n.t('blocks.' + names[index]) +
                `" draggable="true"><div class="gjs-block-column-label">` +
                this.$i18n.t('blocks.' + names[index]) +
                `</div></div>`,

              style: {
                color: bg[index] + '!important',
              },
              label: this.$i18n.t('blocks.' + block[i]),
              parent: this.$i18n.t('blocks.' + names[index]),
              title: this.$i18n.t('blocks.' + names[index]),
            });
            let title = document.querySelector(
              '.gjs-block-categories .gjs-block-category .gjs-title > div#emp-gjs-block-' +
                names[index].toLowerCase(),
            );
            if (title) {
              title.innerHTML =
                '<div class="gjs-block-column-label">' +
                editor.BlockManager.get(block[i]).get('parent') +
                '</div>';
            }
            var getClassBlocks = editor.BlockManager.get(block[i]).attributes.attributes.class;
            let classBlocks = [getClassBlocks, 'block-parent' + index];
            var classes = '';
            for (let j = 0; j < classBlocks.length; j++) {
              classes = classes + ' ' + classBlocks[j];
            }
            editor.BlockManager.get(block[i]).attributes.attributes.class = classes;
          }
        });

        CurrentBlock = allBlocks.filter(function(item) {
          return !CurrentBlock.includes(item)
            ? true
            : CurrentBlock.splice(CurrentBlock.indexOf(item), 1) && false;
        });
        CurrentBlock.forEach(block => {
          editor.BlockManager.remove(block);
        });
      }
      // Remove the "Réseaux sociaux" (Social) widgets from the block panel
      // (Facebook / Twitter / LinkedIn). The component types stay registered so
      // existing saved programs that already use them still render correctly.
      ['facebook_widget', 'social-icons-twitter', 'linkedin_widget'].forEach(id => {
        if (editor.BlockManager.get(id)) {
          editor.BlockManager.remove(id);
        }
      });
    },
    async setHiddenBlockManager() {
      let allCategories = document.querySelectorAll('.gjs-block-categories .gjs-block-category');

      allCategories.forEach((categry, i) => {
        if (i !== 0) {
          allCategories[i].classList.remove('gjs-open');
        } else {
          allCategories[i].classList.add('remove-open-block');
        }
        allCategories[i].addEventListener('click', function() {
          if (allCategories[i].classList.contains('gjs-open')) {
            allCategories[i].classList.remove('gjs-open');
            allCategories[i].classList.add('remove-open-block');
          } else {
            allCategories[i].classList.add('gjs-open');
            allCategories[i].classList.remove('remove-open-block');
          }
          if (allCategories[i].classList.contains('remove-open-block')) {
            allCategories[i].classList.remove('remove-open-block');
          } else {
            allCategories[i].classList.add('remove-open-block');
          }
        });
      });
    },
    createBorderProperty(editor) {
      const styleManager = editor.StyleManager;
      const positions = ['top', 'right', 'bottom', 'left'];
      let self = this;
      const borderRadiusSelector = {
        name: 'Rayon',
        property: 'border-radius-selector',
        type: 'radio',
        defaults: 'full-border-radius',
        list: [
          { value: 'full-border-radius', className: 'icon icon-border-full' },
          { value: 'details-border-radius', className: 'icon icon-border-details' },
        ],
      };
      const borderRadiusValue = {
        name: ' ',
        property: 'border-radius',
        type: 'slider',
        units: ['px', '%'],
        defaults: 0,
        step: 1,
        max: 100,
        min: 0,
      };
      const borderRadiusValues = {
        name: ' ',
        property: 'border-radius',
        type: 'composite',
        properties: [
          ...positions.map(p => {
            return {
              name: ' ',
              property: 'border-' + p + '-left-radius',
              type: 'integer',
              units: ['px', '%'],
              defaults: '0px',
              min: 0,
            };
          }),
        ],
      };
      const borderEdgesSelector = {
        name: ' ',
        property: 'border-edges-selector',
        type: 'radio',
        defaults: 'full-border-edges',
        list: [
          { value: 'top-border-edges', className: 'icon icon-border-edge-top' },
          { value: 'left-border-edges', className: 'icon icon-border-edge-left' },
          { value: 'full-border-edges', className: 'icon icon-border-edge-full' },
          { value: 'right-border-edges', className: 'icon icon-border-edge-right' },
          { value: 'bottom-border-edges', className: 'icon icon-border-edge-bottom' },
        ],
      };
      const borderStyleValue = p => {
        p = p ? p + '-' : '';
        return {
          name: 'Border',
          property: 'border-' + p + 'style',
          type: 'radio',
          defaults: 'none',
          list: [
            {
              value: 'none',
              name: 'none',
              className: 'icon icon-border-style none',
              title: 'sans bordure',
            },
            {
              value: 'solid',
              name: 'solid',
              className: 'icon icon-border-style solid',
              title: 'Solide',
            },
            {
              value: 'dashed',
              name: 'dashed',
              className: 'icon icon-border-style dashed',
              title: 'Dashed',
            },
            {
              value: 'dotted',
              name: 'dotted',
              className: 'icon icon-border-style dotted',
              title: 'Dotted',
            },
          ],
        };
      };
      const borderWidthValue = p => {
        p = p ? p + '-' : '';
        return {
          name: 'Largeur',
          property: 'border-' + p + 'width',
          type: 'integer',
          units: ['px', '%', ''],
          defaults: 0,
          min: 0,
        };
      };
      const borderColorValue = p => {
        p = p ? p + '-' : '';
        return {
          name: 'Couleur',
          property: 'border-' + p + 'color',
          type: 'color',
          defaults: 'black',
        };
      };

      styleManager.addProperty('Border', borderRadiusSelector);
      styleManager.addProperty('Border', borderRadiusValue);
      styleManager.addProperty('Border', borderRadiusValues);
      styleManager.addProperty('Border', borderStyleValue());
      positions.forEach(p => styleManager.addProperty('Border', borderStyleValue(p)));
      styleManager.addProperty('Border', borderEdgesSelector);
      styleManager.addProperty('Border', borderWidthValue());
      positions.forEach(p => styleManager.addProperty('Border', borderWidthValue(p)));
      styleManager.addProperty('Border', borderColorValue());
      positions.forEach(p => styleManager.addProperty('Border', borderColorValue(p)));

      let index = 0;
      let interval = setInterval(() => {
        const borderBlockEl = document.getElementById('gjs-sm-border');
        index++;
        if (borderBlockEl) {
          clearInterval(interval);
          this.addSelectorsEvent();
        }
        if (index === 100) {
          clearInterval(interval);
        }
      }, 100);
    },
    addSelectorsEvent() {
      const borderRadiusEls = document.querySelectorAll(
        'input[type=radio][name=border-radius-selector]',
      );
      const borderEdgesEls = document.querySelectorAll(
        'input[type=radio][name=border-edges-selector]',
      );
      const borderBlockEl = document.getElementById('gjs-sm-border');
      borderBlockEl.classList.add('full-border-radius');
      borderBlockEl.classList.add('full-border-edges');

      borderRadiusEls.forEach(e => {
        e.addEventListener('change', e => {
          const value = e.target.value;
          borderBlockEl.className = borderBlockEl.classList.value
            .split(' ')
            .filter(e => e.indexOf('radius') === -1)
            .join(' ');
          borderBlockEl.classList.add(value);
        });
      });

      borderEdgesEls.forEach(e => {
        e.addEventListener('change', e => {
          const value = e.target.value;
          borderBlockEl.className = borderBlockEl.classList.value
            .split(' ')
            .filter(e => e.indexOf('edges') === -1)
            .join(' ');
          borderBlockEl.classList.add(value);
        });
      });
    },
    // addCustomStyleManager(editor, getParamsClient) {
    //   const styleManager = editor.StyleManager;
    //   const sectors = getParamsClient.display_custom_style_manager.map(sector => {
    //     return sector.name;
    //   });
    //   const buildProps = getParamsClient.display_custom_style_manager.map(property => {
    //     return property.buildProps;
    //   });
    //   const properties = getParamsClient.display_custom_style_manager.map(property => {
    //     return property.properties;
    //   });
    //
    //   sectors.forEach(sector => {
    //     styleManager.addSector(sector, {
    //       name: sector,
    //       open: true,
    //       properties: [
    //         {
    //           name: buildProps.forEach(prop => {
    //             return prop;
    //           })
    //         }
    //       ]
    //     });
    //     const property = properties.forEach(prop => {
    //       return prop.map(p => {
    //         return p;
    //       });
    //     });
    //     styleManager.addProperty(sector, property);
    //   });
    // },
    addSpecificBlocText(customBlock, editor) {
      let self = this;
      let iconClass = 'font';
      const style = `<style>
   [data-class='custom-title'], .custom-title{
   color: #FFFFFF;
   background-color: #E42313;
   font-family: Corporate A BQ !important;
   font-size: 25pt;
   padding: 10px 0.2em;
   text-align: center;
   }
   
  [data-class='custom-sharing'], .custom-sharing{
   font-size: 20pt;
   font-family:  Din Bold !important;
   text-align: center;
   padding: 10px 0.2em;
   color: #252e63;
   }
   [data-class='custom-credit'], .custom-credit{
   z-index: 9999!important;
   font-size: 8pt;
   font-family:  Din Regular ;
   text-align: center;
   padding: 10px 0.2em;
   color: #ffffff;
     width: auto!important;
    height: auto!important;
   }
 
  </style>`;

      if (customBlock === 'custom-sharing') {
        iconClass = 'fa fa-share';
      }
      if (customBlock === 'custom-credit') {
        iconClass = 'icon-icon-block-c';
      }
      if (customBlock === 'custom-title') {
        iconClass = 'fa fa-font';
      }
      editor.BlockManager.add(customBlock, {
        label: customBlock,
        category: 'Text',
        content: `<div data-gjs-type="text" data-class="${customBlock}" class="${customBlock}" >Insert your text here</div>
        ${style}
      `,
        attributes: {
          class: iconClass,
        },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/GrapesMixinBlockManger.js